<div class="bids-filter-container">
  <label class="bids-filter-label fw-bold h5 control-label">{{ bidFilterLabel() }}</label>
  <mat-radio-group
    class="bids-filter-group"
    [value]="selectedBidFilter()"
    (change)="onBidFilterChange($event.value)"
    aria-label="Bid filter options">
    @for (bidType of bidTypes(); track bidType.id) {
      <div class="bids-filter-option material-radio-button">
        <mat-radio-button
          [id]="bidType.id"
          [value]="bidType.value"
          [disableRipple]="true"
          [attr.data-track-elem]="'radio'"
          [attr.data-track-trigger]="'filter'"
          [attr.data-track-name]="bidType.dataTrackName"
          [aria-label]="bidType.ariaLabel">
          {{ bidType.name }}
        </mat-radio-button>
        @if (showAccountManagerDropdowns(bidType.value)) {
          <div class="ms-2 mt-1">
            <app-account-manager-dealer-filter
              [accountManagerDealerFilterType$]="accountManagerEmployeeAggregation.ACTIVE_BIDS"
            ></app-account-manager-dealer-filter>
          </div>
        }
      </div>
    }
  </mat-radio-group>
</div>